// ** React Imports
import { Fragment, useState, useRef } from 'react';

// ** Vertical Menu Items Array
import navigation from '@src/navigation/vertical';

// ** Third Party Components
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';

// ** Vertical Menu Components
import VerticalMenuHeader from './VerticalMenuHeader';
import VerticalNavMenuItems from './VerticalNavMenuItems';
import logo_jalisco from '@src/assets/images/logo/logo_jal_login.png';
import {Flex} from '@chakra-ui/react';

const Sidebar = (props) => {
	// ** Props
	const { menuCollapsed, routerProps, menu, currentActiveItem, skin } = props;

	// ** States
	const [groupOpen, setGroupOpen] = useState([]);
	const [groupActive, setGroupActive] = useState([]);
	const [activeItem, setActiveItem] = useState(null);

	// ** Menu Hover State
	const [menuHover, setMenuHover] = useState(false);

	// ** Ref
	const shadowRef = useRef(null);

	// ** Function to handle Mouse Enter
	const onMouseEnter = () => {
		if (menuCollapsed) {
			setMenuHover(true);
		}
	};

	// ** Scroll Menu
	const scrollMenu = (container) => {
		if (shadowRef && container.scrollTop > 0) {
			if (!shadowRef.current.classList.contains('d-block')) {
				shadowRef.current.classList.add('d-block');
			}
		} else {
			if (shadowRef.current.classList.contains('d-block')) {
				shadowRef.current.classList.remove('d-block');
			}
		}
	};

	return (
		<Fragment>
			<div
				className={classnames(
					'main-menu menu-fixed menu-accordion menu-shadow',
					{
						expanded: menuHover || menuCollapsed === false,
						'menu-light': skin !== 'semi-dark' && skin !== 'dark',
						'menu-dark': skin === 'semi-dark' || skin === 'dark'
					}
				)}
				onMouseEnter={onMouseEnter}
				onMouseLeave={() => setMenuHover(false)}
			>
				{menu ? (
					menu(props)
				) : (
					<Flex flex='1 1 auto' direction='column' position='relative' width='100%' height='100%'>
						{/* Vertical Menu Header */}
						<VerticalMenuHeader
							setGroupOpen={setGroupOpen}
							menuHover={menuHover}
							{...props}
						/>
						{/* Vertical Menu Header Shadow */}
						<div className="shadow-bottom" ref={shadowRef}></div>
						{/* Perfect Scrollbar */}
						<PerfectScrollbar
							className="main-menu-content"
							options={{ wheelPropagation: false }}
							onScrollY={(container) => scrollMenu(container)}
						>
							<ul className="navigation navigation-main">
								<VerticalNavMenuItems
									items={navigation}
									groupActive={groupActive}
									setGroupActive={setGroupActive}
									activeItem={activeItem}
									setActiveItem={setActiveItem}
									groupOpen={groupOpen}
									setGroupOpen={setGroupOpen}
									routerProps={routerProps}
									menuCollapsed={menuCollapsed}
									menuHover={menuHover}
									currentActiveItem={currentActiveItem}
								/>
							</ul>
						</PerfectScrollbar>
						<div className='container_logo_navbar'
							>
								<img
									src={logo_jalisco}
									alt="Logo del estado de Jalisco"
									height={'100px'}
									width={'100px'}
									style={{ margin: 'auto' }}
								/>
							</div>
					</Flex>
				)}
			</div>
		</Fragment>
	);
};

export default Sidebar;
